<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast" :class="typeClass">
      <span class="toast-icon" v-if="type === 'success'">✓</span>
      <span class="toast-icon" v-else-if="type === 'error'">✕</span>
      <span class="toast-icon" v-else-if="type === 'warning'">!</span>
      <span class="toast-msg">{{ message }}</span>
      <span v-if="showClose" class="toast-close" @click="closeToast">×</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data () {
    return {
      visible: false,
      message: '',
      type: 'info',
      duration: 2500,
      showClose: false,
      timer: null
    }
  },
  computed: {
    typeClass () {
      return `toast-${this.type}`
    }
  },
  methods: {
    show (options) {
      const opt = typeof options === 'string' ? { message: options } : options
      this.message = opt.message || ''
      this.type = opt.type || 'info'
      this.duration = opt.duration === undefined ? 2500 : opt.duration
      this.showClose = !!opt.showClose
      this.visible = true
      if (this.timer) clearTimeout(this.timer)
      if (this.duration > 0) {
        this.timer = setTimeout(() => this.closeToast(), this.duration)
      }
    },
    closeToast () {
      this.visible = false
      if (this.timer) clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 220px;
  max-width: 80%;
  padding: 12px 20px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 9999;
  font-size: 14px;
}
.toast-info { border-left: 4px solid #2444cb; }
.toast-success { border-left: 4px solid #2e9e5b; }
.toast-error { border-left: 4px solid #e05656; }
.toast-warning { border-left: 4px solid #e6a23c; }
.toast-icon { font-weight: 700; }
.toast-success .toast-icon { color: #2e9e5b; }
.toast-error .toast-icon { color: #e05656; }
.toast-warning .toast-icon { color: #e6a23c; }
.toast-info .toast-icon { color: #2444cb; }
.toast-close { margin-left: 8px; cursor: pointer; color: #999; font-size: 18px; }
.toast-fade-enter-active, .toast-fade-leave-active { transition: opacity 0.3s; }
.toast-fade-enter, .toast-fade-leave-to { opacity: 0; }
</style>
